"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[242],{

/***/ 33120:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Qd": function() { return /* binding */ AccordionItem; },
/* harmony export */   "Qj": function() { return /* binding */ StyledChevron; },
/* harmony export */   "UQ": function() { return /* binding */ Accordion; },
/* harmony export */   "o4": function() { return /* binding */ AccordionTrigger; },
/* harmony export */   "vF": function() { return /* binding */ AccordionContent; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(90076);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(20950);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(32895);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(20264);
/* harmony import */ var _radix_ui_react_accordion__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(68603);
/* harmony import */ var _radix_ui_react_icons__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(77385);
/* harmony import */ var _stitches_config__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(62713);







var slideDown = (0,_stitches_config__WEBPACK_IMPORTED_MODULE_2__/* .keyframes */ .F4)({
    from: {
        height: 0
    },
    to: {
        height: "var(--radix-accordion-content-height)"
    }
});
var slideUp = (0,_stitches_config__WEBPACK_IMPORTED_MODULE_2__/* .keyframes */ .F4)({
    from: {
        height: "var(--radix-accordion-content-height)"
    },
    to: {
        height: 0
    }
});
var StyledAccordion = (0,_stitches_config__WEBPACK_IMPORTED_MODULE_2__/* .styled */ .zo)(_radix_ui_react_accordion__WEBPACK_IMPORTED_MODULE_3__/* .Root */ .fC, {
    width: "100%",
    mb: "$10"
});
var StyledHeader = (0,_stitches_config__WEBPACK_IMPORTED_MODULE_2__/* .styled */ .zo)(_radix_ui_react_accordion__WEBPACK_IMPORTED_MODULE_3__/* .Header */ .h4, {
    all: "unset",
    display: "flex"
});
var StyledTrigger = (0,_stitches_config__WEBPACK_IMPORTED_MODULE_2__/* .styled */ .zo)(_radix_ui_react_accordion__WEBPACK_IMPORTED_MODULE_3__/* .Trigger */ .xz, {
    fontFamily: "inherit",
    backgroundColor: "transparent",
    padding: "0 20px",
    height: 45,
    flex: 1,
    pl: "$3",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    borderBottom: "1px solid $colors$gray6"
});
var StyledContent = (0,_stitches_config__WEBPACK_IMPORTED_MODULE_2__/* .styled */ .zo)(_radix_ui_react_accordion__WEBPACK_IMPORTED_MODULE_3__/* .Content */ .VY, {
    overflow: "hidden",
    display: "flex",
    flexDirection: "column",
    mt: "$2",
    '&[data-state="open"]': {
        animation: "".concat(slideDown, " 300ms cubic-bezier(0.87, 0, 0.13, 1)")
    },
    '&[data-state="closed"]': {
        animation: "".concat(slideUp, " 300ms cubic-bezier(0.87, 0, 0.13, 1)")
    }
});
var StyledChevron = (0,_stitches_config__WEBPACK_IMPORTED_MODULE_2__/* .styled */ .zo)(_radix_ui_react_icons__WEBPACK_IMPORTED_MODULE_1__/* .ChevronDownIcon */ .v4q, {
    color: "$gray9",
    transition: "transform 300ms cubic-bezier(0.87, 0, 0.13, 1)",
    "[data-state=open] &": {
        transform: "rotate(180deg)"
    }
});
var AccordionTrigger = function(_param) {
    var children = _param.children, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_param, [
        "children"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(StyledHeader, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(StyledTrigger, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, props), {
            children: [
                children,
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(StyledChevron, {})
            ]
        }))
    });
};

var Accordion = StyledAccordion;
var AccordionItem = _radix_ui_react_accordion__WEBPACK_IMPORTED_MODULE_3__/* .Item */ .ck;
var AccordionContent = StyledContent;


/***/ }),

/***/ 53037:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B1": function() { return /* binding */ FormTextarea; },
/* harmony export */   "lX": function() { return /* binding */ FormLabel; },
/* harmony export */   "p7": function() { return /* binding */ FormRow; },
/* harmony export */   "rM": function() { return /* binding */ FormHelperError; },
/* harmony export */   "wK": function() { return /* binding */ FormHelper; },
/* harmony export */   "yt": function() { return /* binding */ FormInput; }
/* harmony export */ });
/* harmony import */ var _stitches_config__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(62713);

var FormRow = (0,_stitches_config__WEBPACK_IMPORTED_MODULE_0__/* .styled */ .zo)("div", {
    display: "flex",
    flexDirection: "column",
    alignItems: "start",
    gap: "$2",
    mb: "$5"
});
var FormLabel = (0,_stitches_config__WEBPACK_IMPORTED_MODULE_0__/* .styled */ .zo)("label", {
    width: "100%",
    display: "block",
    fontSize: "18px",
    lineHeight: "24px",
    fontWeight: 600,
    color: "$gray11"
});
var FormInput = (0,_stitches_config__WEBPACK_IMPORTED_MODULE_0__/* .styled */ .zo)("input", {
    "&[type]": {
        appearance: "none",
        borderWidth: "0",
        boxSizing: "border-box",
        fontFamily: "inherit",
        margin: "0",
        outline: "none",
        padding: "0",
        minWidth: 300,
        WebkitTapHighlightColor: "rgba(0,0,0,0)",
        backgroundColor: "$gray3",
        boxShadow: "0 0 0 1px $colors$gray7",
        borderRadius: "$1",
        px: "$2",
        py: "$1",
        fontSize: "$1",
        color: "$gray11",
        "&:hover": {
            backgroundColor: "$gray4",
            boxShadow: "0 0 0 1px $colors$gray8"
        },
        "&:focus": {
            backgroundColor: "$gray4",
            boxShadow: "0 0 0 1px $colors$gray8"
        },
        "&::placeholder": {
            color: "$gray9"
        }
    },
    '&[type="date"]::-webkit-calendar-picker-indicator': {
        background: "url(/static/img/Calendar.svg) no-repeat",
        mt: "$1"
    }
});
var FormTextarea = (0,_stitches_config__WEBPACK_IMPORTED_MODULE_0__/* .styled */ .zo)("textarea", {
    outline: "none",
    minWidth: 300,
    backgroundColor: "$gray3",
    boxShadow: "0 0 0 1px $colors$gray7",
    borderRadius: "$1",
    py: "$2",
    px: "$2",
    fontSize: "$1",
    "&:hover": {
        backgroundColor: "$gray4",
        boxShadow: "0 0 0 1px $colors$gray8"
    },
    "&:focus": {
        backgroundColor: "$gray4",
        boxShadow: "0 0 0 1px $colors$gray8"
    },
    "&::placeholder": {
        color: "$gray9"
    }
});
var FormHelper = (0,_stitches_config__WEBPACK_IMPORTED_MODULE_0__/* .styled */ .zo)("p", {
    color: "$gray9",
    fontSize: "$1"
});
var FormHelperError = (0,_stitches_config__WEBPACK_IMPORTED_MODULE_0__/* .styled */ .zo)("p", {
    color: "$orange11"
});


/***/ }),

/***/ 69887:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Typography; }
/* harmony export */ });
/* harmony import */ var _stitches_config__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(62713);

var Typography = (0,_stitches_config__WEBPACK_IMPORTED_MODULE_0__/* .styled */ .zo)("p", {
    variants: {
        size: {
            display1: {
                fontSize: "72px",
                lineHeight: "84px",
                letterSpacing: "-0.3px"
            },
            display2: {
                fontSize: "48px",
                lineHeight: "62px",
                letterSpacing: "-0.3px"
            },
            h1: {
                fontSize: "36px",
                lineHeight: "42px",
                letterSpacing: "-0.3px"
            },
            h2: {
                fontSize: "30px",
                lineHeight: "40px",
                letterSpacing: "-0.3px"
            },
            h3: {
                fontSize: "22px",
                lineHeight: "28px"
            },
            h4: {
                fontSize: "18px",
                lineHeight: "24px"
            },
            subheading: {
                fontSize: "15px",
                lineHeight: "20px"
            },
            paragraph: {
                fontSize: "18px",
                lineHeight: "28.8px",
                letterSpacing: "0.2px"
            },
            subparagraph: {
                fontSize: "14px",
                lineHeight: "18px",
                letterSpacing: "0.2px"
            }
        },
        color: {
            gray: {
                color: "$gray10"
            },
            orange: {
                color: "$orange11"
            }
        }
    },
    defaultVariants: {
        size: "paragraph",
        color: "gray"
    }
});


/***/ }),

/***/ 9242:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "UQ": function() { return /* reexport */ Accordion/* Accordion */.UQ; },
  "vF": function() { return /* reexport */ Accordion/* AccordionContent */.vF; },
  "Qd": function() { return /* reexport */ Accordion/* AccordionItem */.Qd; },
  "o4": function() { return /* reexport */ Accordion/* AccordionTrigger */.o4; },
  "xu": function() { return /* reexport */ Box; },
  "zx": function() { return /* reexport */ Button; },
  "W2": function() { return /* reexport */ Container; },
  "Vq": function() { return /* reexport */ Dialog; },
  "GG": function() { return /* reexport */ DialogClose; },
  "cZ": function() { return /* reexport */ DialogContent; },
  "Be": function() { return /* reexport */ DialogDescription; },
  "$N": function() { return /* reexport */ DialogTitle; },
  "h_": function() { return /* reexport */ DropdownMenu; },
  "AW": function() { return /* reexport */ DropdownMenuContent; },
  "Xi": function() { return /* reexport */ DropdownMenuItem; },
  "VD": function() { return /* reexport */ DropdownMenuSeparator; },
  "$F": function() { return /* reexport */ DropdownMenuTrigger; },
  "kC": function() { return /* reexport */ Flex; },
  "wK": function() { return /* reexport */ Form/* FormHelper */.wK; },
  "rM": function() { return /* reexport */ Form/* FormHelperError */.rM; },
  "yt": function() { return /* reexport */ Form/* FormInput */.yt; },
  "lX": function() { return /* reexport */ Form/* FormLabel */.lX; },
  "p7": function() { return /* reexport */ Form/* FormRow */.p7; },
  "B1": function() { return /* reexport */ Form/* FormTextarea */.B1; },
  "X6": function() { return /* reexport */ Heading; },
  "hU": function() { return /* reexport */ IconButton; },
  "TK": function() { return /* reexport */ LoadingSpinner; },
  "xr": function() { return /* reexport */ ScrollArea; },
  "lj": function() { return /* reexport */ ScrollAreaCorner; },
  "gb": function() { return /* reexport */ ScrollAreaScrollbar; },
  "q4": function() { return /* reexport */ ScrollAreaThumb; },
  "ap": function() { return /* reexport */ ScrollAreaViewport; },
  "mQ": function() { return /* reexport */ Tabs; },
  "nU": function() { return /* reexport */ TabsContent; },
  "dr": function() { return /* reexport */ TabsList; },
  "SP": function() { return /* reexport */ TabsTrigger; },
  "xv": function() { return /* reexport */ Text; },
  "u": function() { return /* reexport */ Tooltip; },
  "_v": function() { return /* reexport */ TooltipContent; },
  "aJ": function() { return /* reexport */ TooltipTrigger; },
  "ZT": function() { return /* reexport */ Typography/* Typography */.Z; }
});

// UNUSED EXPORTS: DialogTrigger, StyledChevron, TooltipArrow

// EXTERNAL MODULE: ./src/ui/Accordion.tsx
var Accordion = __webpack_require__(33120);
// EXTERNAL MODULE: ./src/stitches.config.ts + 1 modules
var stitches_config = __webpack_require__(62713);
;// CONCATENATED MODULE: ./src/ui/Box.ts

var Box = (0,stitches_config/* styled */.zo)("div", {});

;// CONCATENATED MODULE: ./src/ui/Button.ts

var Button = (0,stitches_config/* styled */.zo)("button", {
    display: "inline-flex",
    justifyContent: "center",
    alignItems: "center",
    fontSize: "$2",
    "&:disabled": {
        opacity: 0.5,
        pointerEvents: "none"
    },
    variants: {
        size: {
            md: {
                px: "$3",
                py: "$1",
                br: "$1"
            },
            lg: {
                px: "$4",
                py: "$3",
                br: "$1"
            }
        },
        color: {
            gray: {
                color: "$gray1",
                backgroundColor: "$gray11",
                "&:hover": {
                    backgroundColor: "$gray12"
                }
            },
            orange: {
                color: "white",
                backgroundColor: "$orange11",
                "&:hover": {
                    backgroundColor: "$orange12"
                }
            },
            violet: {
                color: "$gray1",
                backgroundColor: "$violet11",
                "&:hover": {
                    backgroundColor: "$violet12"
                }
            }
        },
        variant: {
            solid: {},
            ghost: {
                backgroundColor: "transparent",
                boxShadow: "none"
            },
            subtle: {}
        }
    },
    compoundVariants: [
        {
            color: "gray",
            variant: "ghost",
            css: {
                backgroundColor: "transparent",
                color: "$gray11",
                "&:hover": {
                    backgroundColor: "$gray4"
                },
                "&:active": {
                    backgroundColor: "$gray5"
                }
            }
        },
        {
            color: "orange",
            variant: "ghost",
            css: {
                backgroundColor: "transparent",
                color: "$orange11",
                "&:hover": {
                    backgroundColor: "$orange4"
                },
                "&:active": {
                    backgroundColor: "$orange5"
                }
            }
        },
        {
            color: "gray",
            variant: "subtle",
            css: {
                backgroundColor: "$gray3",
                color: "$gray11",
                "&:hover": {
                    backgroundColor: "$gray4"
                },
                "&:active": {
                    backgroundColor: "$gray5"
                }
            }
        }, 
    ],
    defaultVariants: {
        size: "md",
        color: "gray",
        variant: "solid"
    }
});

;// CONCATENATED MODULE: ./src/ui/Container.ts

var Container = (0,stitches_config/* styled */.zo)("div", {
    ml: "auto",
    mr: "auto",
    px: "$5",
    "@sm": {
        maxWidth: "640px"
    },
    "@md": {
        maxWidth: "768px"
    },
    "@lg": {
        maxWidth: "1024px"
    },
    "@xl": {
        maxWidth: "1280px"
    }
});

// EXTERNAL MODULE: ../node_modules/.pnpm/@swc+helpers@0.4.2/node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(95124);
// EXTERNAL MODULE: ../node_modules/.pnpm/@swc+helpers@0.4.2/node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(90076);
// EXTERNAL MODULE: ../node_modules/.pnpm/@swc+helpers@0.4.2/node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(20950);
// EXTERNAL MODULE: ../node_modules/.pnpm/@swc+helpers@0.4.2/node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(32895);
// EXTERNAL MODULE: ../node_modules/.pnpm/react@17.0.2/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(20264);
// EXTERNAL MODULE: ../node_modules/.pnpm/react@17.0.2/node_modules/react/index.js
var react = __webpack_require__(49231);
// EXTERNAL MODULE: ../node_modules/.pnpm/@radix-ui+react-dialog@0.1.7_x5eodlisouwznpi4y2wdaadbie/node_modules/@radix-ui/react-dialog/dist/index.module.js
var index_module = __webpack_require__(23710);
// EXTERNAL MODULE: ../node_modules/.pnpm/@radix-ui+react-icons@1.1.0_react@17.0.2/node_modules/@radix-ui/react-icons/dist/react-icons.esm.js
var react_icons_esm = __webpack_require__(77385);
;// CONCATENATED MODULE: ./src/ui/IconButton.ts

var IconButton = (0,stitches_config/* styled */.zo)("button", {
    display: "inline-flex",
    justifyContent: "center",
    alignItems: "center",
    fontSize: "$2",
    "&:disabled": {
        opacity: 0.5,
        cursor: "not-allowed"
    },
    variants: {
        size: {
            md: {
                p: "$2",
                br: "$1"
            }
        },
        color: {
            gray: {
                color: "$gray11",
                backgroundColor: "$gray3",
                "&:hover": {
                    backgroundColor: "$gray4"
                },
                "&:active": {
                    backgroundColor: "$gray5"
                }
            }
        },
        variant: {
            solid: {},
            ghost: {
                backgroundColor: "transparent"
            }
        }
    },
    compoundVariants: [
        {
            color: "gray",
            variant: "ghost",
            css: {
                backgroundColor: "transparent"
            }
        }, 
    ],
    defaultVariants: {
        size: "md",
        color: "gray",
        variant: "ghost"
    }
});

;// CONCATENATED MODULE: ./src/ui/Dialog.tsx










var overlayShow = (0,stitches_config/* keyframes */.F4)({
    "0%": {
        opacity: 0
    },
    "100%": {
        opacity: 1
    }
});
var _obj;
var StyledOverlay = (0,stitches_config/* styled */.zo)(index_module/* Overlay */.aV, (_obj = {
    backgroundColor: "rgba(8, 8, 8, 0.7)",
    position: "fixed",
    inset: 0
}, (0,_define_property/* default */.Z)(_obj, ".".concat(stitches_config/* darkTheme */.$_, " &"), {
    backgroundColor: "rgba(46, 46, 46, 0.7)"
}), (0,_define_property/* default */.Z)(_obj, "@media (prefers-reduced-motion: no-preference)", {
    animation: "".concat(overlayShow, " 150ms cubic-bezier(0.16, 1, 0.3, 1)")
}), _obj));
function Dialog(_param) {
    var children = _param.children, props = (0,_object_without_properties/* default */.Z)(_param, [
        "children"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_module/* Root */.fC, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_module/* Portal */.h_, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledOverlay, {}),
                children
            ]
        })
    }));
}
var contentShow = (0,stitches_config/* keyframes */.F4)({
    "0%": {
        opacity: 0,
        transform: "translate(-50%, -48%) scale(.96)"
    },
    "100%": {
        opacity: 1,
        transform: "translate(-50%, -50%) scale(1)"
    }
});
var StyledContent = (0,stitches_config/* styled */.zo)(index_module/* Content */.VY, {
    backgroundColor: "$gray1",
    color: "$gray11",
    br: "$2",
    boxShadow: "0px 0px 33px rgba(0, 0, 0, 0.08)",
    position: "fixed",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "90vw",
    maxWidth: "550px",
    maxHeight: "85vh",
    px: "$6",
    pt: 48,
    pb: "$5",
    overflow: "scroll",
    "@media (prefers-reduced-motion: no-preference)": {
        animation: "".concat(contentShow, " 150ms cubic-bezier(0.16, 1, 0.3, 1)"),
        willChange: "transform"
    },
    "&:focus": {
        outline: "none"
    }
});
var StyledCloseButton = (0,stitches_config/* styled */.zo)(index_module/* Close */.x8, {
    position: "absolute",
    top: "$4",
    right: "$6"
});
var DialogContent = /*#__PURE__*/ (0,react.forwardRef)(function(_param, forwardedRef) /*#__PURE__*/ {
    var children = _param.children, props = (0,_object_without_properties/* default */.Z)(_param, [
        "children"
    ]);
    return (0,jsx_runtime.jsxs)(StyledContent, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        ref: forwardedRef,
        children: [
            children,
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledCloseButton, {
                asChild: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_icons_esm/* Cross1Icon */.ypG, {
                        width: 15,
                        height: 15
                    })
                })
            })
        ]
    }));
});

var DialogTrigger = index_module/* Trigger */.xz;
var DialogClose = index_module/* Close */.x8;
var DialogTitle = index_module/* Title */.Dx;
var DialogDescription = index_module/* Description */.dk;

// EXTERNAL MODULE: ../node_modules/.pnpm/@radix-ui+react-dropdown-menu@0.1.6_x5eodlisouwznpi4y2wdaadbie/node_modules/@radix-ui/react-dropdown-menu/dist/index.module.js + 1 modules
var dist_index_module = __webpack_require__(32529);
;// CONCATENATED MODULE: ./src/ui/DropdownMenu.ts


var DropdownMenu = dist_index_module/* Root */.fC;
var DropdownMenuTrigger = dist_index_module/* Trigger */.xz;
var DropdownMenuSeparator = (0,stitches_config/* styled */.zo)(dist_index_module/* Separator */.Z0, {
    height: 1,
    mx: "-$3",
    backgroundColor: "$gray6"
});
var slideUpAndFade = (0,stitches_config/* keyframes */.F4)({
    "0%": {
        opacity: 0,
        transform: "translateY(2px)"
    },
    "100%": {
        opacity: 1,
        transform: "translateY(0)"
    }
});
var slideRightAndFade = (0,stitches_config/* keyframes */.F4)({
    "0%": {
        opacity: 0,
        transform: "translateX(-2px)"
    },
    "100%": {
        opacity: 1,
        transform: "translateX(0)"
    }
});
var slideDownAndFade = (0,stitches_config/* keyframes */.F4)({
    "0%": {
        opacity: 0,
        transform: "translateY(-2px)"
    },
    "100%": {
        opacity: 1,
        transform: "translateY(0)"
    }
});
var slideLeftAndFade = (0,stitches_config/* keyframes */.F4)({
    "0%": {
        opacity: 0,
        transform: "translateX(2px)"
    },
    "100%": {
        opacity: 1,
        transform: "translateX(0)"
    }
});
var DropdownMenuContent = (0,stitches_config/* styled */.zo)(dist_index_module/* Content */.VY, {
    minWidth: 80,
    backgroundColor: "$gray1",
    br: "$1",
    border: "1px solid $gray6",
    overflow: "hidden",
    display: "flex",
    flexDirection: "column",
    gap: "$2",
    p: "$3",
    "@media (prefers-reduced-motion: no-preference)": {
        animationDuration: "400ms",
        animationTimingFunction: "cubic-bezier(0.16, 1, 0.3, 1)",
        willChange: "transform, opacity",
        '&[data-state="open"]': {
            '&[data-side="top"]': {
                animationName: slideDownAndFade
            },
            '&[data-side="right"]': {
                animationName: slideLeftAndFade
            },
            '&[data-side="bottom"]': {
                animationName: slideUpAndFade
            },
            '&[data-side="left"]': {
                animationName: slideRightAndFade
            }
        }
    }
});
var DropdownMenuItem = (0,stitches_config/* styled */.zo)(dist_index_module/* Item */.ck, {
    unset: "all",
    fontSize: "$2",
    lineHeight: "1",
    display: "flex",
    gap: "$2",
    alignItems: "center",
    justifyContent: "space-between",
    whiteSpace: "nowrap",
    py: "$2",
    pl: "$2",
    pr: "$5",
    br: "$1",
    position: "relative",
    userSelect: "none",
    cursor: "pointer",
    variants: {
        color: {
            gray: {
                color: "$gray9",
                "&:hover": {
                    color: "$gray11",
                    backgroundColor: "$gray4"
                },
                "&:active": {
                    color: "$gray11",
                    backgroundColor: "$gray5"
                },
                "&:focus": {
                    outline: "none",
                    backgroundColor: "$gray5",
                    color: "$gray11"
                }
            },
            red: {
                color: "$red11",
                "&:hover": {
                    color: "$red11",
                    backgroundColor: "$red4"
                },
                "&:active": {
                    color: "$red11",
                    backgroundColor: "$red5"
                },
                "&:focus": {
                    outline: "none",
                    backgroundColor: "$red5",
                    color: "$red11"
                }
            }
        },
        selected: {
            true: {
                backgroundColor: "$gray3"
            }
        }
    },
    defaultVariants: {
        color: "gray"
    }
});

;// CONCATENATED MODULE: ./src/ui/Flex.ts

var Flex = (0,stitches_config/* styled */.zo)("div", {
    display: "flex",
    variants: {
        direction: {
            row: {
                flexDirection: "row"
            },
            column: {
                flexDirection: "column"
            },
            rowReverse: {
                flexDirection: "row-reverse"
            },
            columnReverse: {
                flexDirection: "column-reverse"
            }
        },
        align: {
            start: {
                alignItems: "flex-start"
            },
            center: {
                alignItems: "center"
            },
            end: {
                alignItems: "flex-end"
            },
            stretch: {
                alignItems: "stretch"
            },
            baseline: {
                alignItems: "baseline"
            }
        },
        justify: {
            start: {
                justifyContent: "flex-start"
            },
            center: {
                justifyContent: "center"
            },
            end: {
                justifyContent: "flex-end"
            },
            between: {
                justifyContent: "space-between"
            }
        },
        wrap: {
            noWrap: {
                flexWrap: "nowrap"
            },
            wrap: {
                flexWrap: "wrap"
            },
            wrapReverse: {
                flexWrap: "wrap-reverse"
            }
        },
        gap: {
            1: {
                gap: "$1"
            },
            2: {
                gap: "$2"
            },
            3: {
                gap: "$3"
            },
            4: {
                gap: "$4"
            },
            5: {
                gap: "$5"
            },
            6: {
                gap: "$6"
            },
            7: {
                gap: "$7"
            },
            8: {
                gap: "$8"
            },
            9: {
                gap: "$9"
            },
            10: {
                gap: "$10"
            }
        }
    },
    defaultVariants: {
        direction: "row",
        align: "stretch",
        justify: "start",
        wrap: "noWrap"
    }
});

;// CONCATENATED MODULE: ./src/ui/Heading.ts

/**
 * @deprecated Use `Typography` instead.
 */ var Heading = (0,stitches_config/* styled */.zo)("p", {
    fontWeight: 700,
    color: "$gray11",
    variants: {
        size: {
            lg: {
                fontSize: "$4"
            },
            xl: {
                fontSize: "$5"
            },
            "2xl": {
                fontSize: "$6",
                letterSpacing: "-0.3px",
                lineHeight: "36px"
            },
            "3xl": {
                fontSize: "$7",
                letterSpacing: "-0.3px",
                lineHeight: "43px"
            },
            "4xl": {
                fontSize: "$8",
                letterSpacing: "-0.3px",
                lineHeight: "58px"
            },
            "5xl": {
                fontSize: "$9",
                letterSpacing: "-0.3px",
                lineHeight: "86px"
            }
        }
    },
    defaultVariants: {
        size: "lg"
    }
});

;// CONCATENATED MODULE: ./src/ui/LoadingSpinner.ts

var spin = (0,stitches_config/* keyframes */.F4)({
    to: {
        transform: "rotate(360deg)"
    }
});
var LoadingSpinner = (0,stitches_config/* styled */.zo)("div", {
    position: "relative",
    px: "$4",
    "&::before": {
        content: "",
        boxSizing: "border-box",
        position: "absolute",
        top: "50%",
        left: "50%",
        width: "$4",
        height: "$4",
        mt: "-8px",
        ml: "-8px",
        br: "$round",
        border: "1px solid $colors$gray8",
        borderTopColor: "$gray11",
        animation: "".concat(spin, " .7s linear infinite")
    }
});

// EXTERNAL MODULE: ../node_modules/.pnpm/@radix-ui+react-scroll-area@0.1.4_react@17.0.2/node_modules/@radix-ui/react-scroll-area/dist/index.module.js + 1 modules
var react_scroll_area_dist_index_module = __webpack_require__(47202);
;// CONCATENATED MODULE: ./src/ui/ScrollArea.tsx


var SCROLLBAR_SIZE = 10;
var StyledScrollArea = (0,stitches_config/* styled */.zo)(react_scroll_area_dist_index_module/* Root */.fC, {
    width: "100%",
    overflow: "hidden"
});
var StyledViewport = (0,stitches_config/* styled */.zo)(react_scroll_area_dist_index_module/* Viewport */.l_, {
    width: "100%",
    pb: "$4"
});
var StyledScrollbar = (0,stitches_config/* styled */.zo)(react_scroll_area_dist_index_module/* Scrollbar */.LW, {
    mr: "$2",
    display: "flex",
    // ensures no selection
    userSelect: "none",
    // disable browser handling of all panning and zooming gestures on touch devices
    touchAction: "none",
    padding: 2,
    background: "$gray2",
    transition: "background 160ms ease-out",
    borderRadius: SCROLLBAR_SIZE,
    "&:hover": {
        background: "$gray4"
    },
    '&[data-orientation="vertical"]': {
        width: SCROLLBAR_SIZE
    },
    '&[data-orientation="horizontal"]': {
        flexDirection: "column",
        height: SCROLLBAR_SIZE
    }
});
var StyledThumb = (0,stitches_config/* styled */.zo)(react_scroll_area_dist_index_module/* Thumb */.bU, {
    flex: 1,
    background: "$gray9",
    borderRadius: SCROLLBAR_SIZE,
    // increase target size for touch devices https://www.w3.org/WAI/WCAG21/Understanding/target-size.html
    position: "relative",
    "&::before": {
        content: '""',
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        width: "100%",
        height: "100%",
        minWidth: 44,
        minHeight: 44
    }
});
var StyledCorner = (0,stitches_config/* styled */.zo)(react_scroll_area_dist_index_module/* Corner */.Ns, {
    background: "$gray8"
});
var ScrollArea = StyledScrollArea;
var ScrollAreaViewport = StyledViewport;
var ScrollAreaScrollbar = StyledScrollbar;
var ScrollAreaThumb = StyledThumb;
var ScrollAreaCorner = StyledCorner;

;// CONCATENATED MODULE: ./src/ui/Text.ts

/**
 * @deprecated Use `Typography` instead.
 */ var Text = (0,stitches_config/* styled */.zo)("p", {
    variants: {
        size: {
            xs: {
                fontSize: "$1",
                color: "$gray9",
                letterSpacing: "0.2px",
                lineHeight: "18px"
            },
            sm: {
                fontSize: "$2",
                color: "$gray9",
                letterSpacing: "0.2px",
                lineHeight: "20.4px"
            },
            md: {
                fontSize: "$3",
                letterSpacing: "0.2px",
                lineHeight: "28.8px"
            },
            action: {
                fontFamily: "$lato",
                fontSize: "$2",
                letterSpacing: "0.2px",
                lineHeight: "20.4px"
            }
        },
        color: {
            gray: {
                color: "$gray10"
            },
            orange: {
                color: "$orange11"
            }
        }
    },
    defaultVariants: {
        color: "gray",
        size: "md"
    }
});

// EXTERNAL MODULE: ../node_modules/.pnpm/@radix-ui+react-tooltip@0.1.7_sfoxds7t5ydpegc3knd667wn6m/node_modules/@radix-ui/react-tooltip/dist/index.module.js + 2 modules
var react_tooltip_dist_index_module = __webpack_require__(48633);
;// CONCATENATED MODULE: ./src/ui/Tooltip.tsx


var Tooltip = react_tooltip_dist_index_module/* Root */.fC;
var TooltipTrigger = react_tooltip_dist_index_module/* Trigger */.xz;
var Tooltip_slideUpAndFade = (0,stitches_config/* keyframes */.F4)({
    "0%": {
        opacity: 0,
        transform: "translateY(2px)"
    },
    "100%": {
        opacity: 1,
        transform: "translateY(0)"
    }
});
var Tooltip_slideRightAndFade = (0,stitches_config/* keyframes */.F4)({
    "0%": {
        opacity: 0,
        transform: "translateX(-2px)"
    },
    "100%": {
        opacity: 1,
        transform: "translateX(0)"
    }
});
var Tooltip_slideDownAndFade = (0,stitches_config/* keyframes */.F4)({
    "0%": {
        opacity: 0,
        transform: "translateY(-2px)"
    },
    "100%": {
        opacity: 1,
        transform: "translateY(0)"
    }
});
var Tooltip_slideLeftAndFade = (0,stitches_config/* keyframes */.F4)({
    "0%": {
        opacity: 0,
        transform: "translateX(2px)"
    },
    "100%": {
        opacity: 1,
        transform: "translateX(0)"
    }
});
var TooltipContent = (0,stitches_config/* styled */.zo)(react_tooltip_dist_index_module/* Content */.VY, {
    borderRadius: 4,
    py: "$3",
    px: "$4",
    fontSize: "$1",
    lineHeight: "1",
    br: "$1",
    backgroundColor: "$gray4",
    color: "$gray11",
    boxShadow: "hsl(206 22% 7% / 35%) 0px 10px 38px -10px, hsl(206 22% 7% / 20%) 0px 10px 20px -15px",
    "@media (prefers-reduced-motion: no-preference)": {
        animationDuration: "400ms",
        animationTimingFunction: "cubic-bezier(0.16, 1, 0.3, 1)",
        willChange: "transform, opacity",
        '&[data-state="delayed-open"]': {
            '&[data-side="top"]': {
                animationName: Tooltip_slideDownAndFade
            },
            '&[data-side="right"]': {
                animationName: Tooltip_slideLeftAndFade
            },
            '&[data-side="bottom"]': {
                animationName: Tooltip_slideUpAndFade
            },
            '&[data-side="left"]': {
                animationName: Tooltip_slideRightAndFade
            }
        }
    }
});
var TooltipArrow = (0,stitches_config/* styled */.zo)(react_tooltip_dist_index_module/* Arrow */.Eh, {
    fill: "white"
});

// EXTERNAL MODULE: ../node_modules/.pnpm/@radix-ui+react-tabs@0.1.5_react@17.0.2/node_modules/@radix-ui/react-tabs/dist/index.module.js
var react_tabs_dist_index_module = __webpack_require__(2911);
;// CONCATENATED MODULE: ./src/ui/Tabs.ts


var StyledTabs = (0,stitches_config/* styled */.zo)(react_tabs_dist_index_module/* Root */.fC, {
    display: "flex",
    flexDirection: "column"
});
var StyledList = (0,stitches_config/* styled */.zo)(react_tabs_dist_index_module/* List */.aV, {
    display: "flex",
    gap: "$8",
    mb: "$8"
});
var Tabs_StyledContent = (0,stitches_config/* styled */.zo)(react_tabs_dist_index_module/* Content */.VY);
var StyledTrigger = (0,stitches_config/* styled */.zo)(react_tabs_dist_index_module/* TabsTrigger */.SP, {
    fontSize: "$2",
    color: "$gray9",
    pb: "$2",
    "&:hover": {
        color: "$gray10"
    },
    '&[data-state="active"]': {
        color: "$gray12",
        fontWeight: 600,
        boxShadow: "0 1px 0 0 $colors$gray12"
    }
});
var Tabs = StyledTabs;
var TabsList = StyledList;
var TabsTrigger = StyledTrigger;
var TabsContent = Tabs_StyledContent;

// EXTERNAL MODULE: ./src/ui/Typography.ts
var Typography = __webpack_require__(69887);
// EXTERNAL MODULE: ./src/ui/Form.ts
var Form = __webpack_require__(53037);
;// CONCATENATED MODULE: ./src/ui/index.ts


















/***/ })

}]);